import { Router } from "router-manager/parts";
import { API, APIError } from "services/api-utils/api-creator";
import { makeEvent } from "services/events";
import { removeToken } from "Session";

function onRedirectToLogin() {
  apiJWT.deleteTokens();
  removeToken();
  makeEvent("logout");
  Router.push("/login");
}

export const apiJWT = new API({
  apiName: "powerhub",
  baseUrl: process.env.REACT_APP_DEFAULT_API || "",
  ignoreAuth: (request) => request.endpoint === "/auth/token",
  onRedirectToLogin,

  async refreshTokenFunction(prevRefreshToken) {
    const api = new API();
    try {
      const { data } = await api.post(
        `https://novapowerhub.com.br/api/auth/refresh?refreshToken=${prevRefreshToken}`,
      );
      return {
        newAccessToken: data.access_token,
        newRefreshToken: data.refresh_token
      };
    } catch (e) {
      // e.response?.data?.message ? Ver isso.
      onRedirectToLogin();
      throw e;
    }
  }
});

apiJWT.useResponseMiddleware(async (response) => {
  // O erro 401 agora é tratado automaticamente no api-creator
  // com retry após refresh do token. Se chegar aqui, significa
  // que o refresh falhou ou não está configurado
  if (response.status === 401) {
    onRedirectToLogin();
    return Promise.reject(new APIError("Sessão expirada"));
  }

  return response;
});
